import { defineComponent, defineStore } from "~/utils/define-component";

export default defineComponent(() => ({
  async update({ id, quantity }) {
    window.dispatchEvent(
      new CustomEvent("update-cart", { detail: { id, quantity } }),
    );
  },

  async handleQuantityChange(e: Event) {
    const el = e.target as HTMLInputElement;

    try {
      const { id, value } = el;

      this.update({ id, quantity: value });
    } catch (error) {
      console.log(error);
    }
  },

  async handleRemove(e: PointerEvent) {
    const target = e.target as HTMLAnchorElement;

    if (!target || target.tagName !== "A") {
      console.log('The remove-button has to be an <a href="url/to/remove">');
      return;
    }

    try {
      const url = new URL(target.href, window.location.origin);
      const removedVariantId = url.searchParams.get("id").split(":")[0];

      this.update({ id: removedVariantId, quantity: 0 });
    } catch (error) {
      console.log(error);
    }
  },
}));
